import { Link } from "react-router";
import { Screen } from "../PodContext";
import "./Footer.css";

const Footer = () => {
  return (<div className="pod-footer">
    <Link to={Screen.FAQ}>
      <img src={'/assets/icons/circle-info.svg'} alt="question" />
    </Link>
  </div>)
}

export default Footer;